import { Map } from 'immutable';

import { ADD, ADD_MULTIPLE, REMOVE, UPDATE } from './constants';
import DonationCreditRule from './model';

export type AddAction = {
  type: typeof ADD;
  donationCreditRule: DonationCreditRule;
};
export const addAction = (donationCreditRule: DonationCreditRule): AddAction => ({
  type: ADD,
  donationCreditRule,
});

export type AddMultipleAction = {
  type: typeof ADD_MULTIPLE;
  donationCreditRules: Map<string, DonationCreditRule>;
};
export const addMultipleAction = (
  donationCreditRules: Map<string, DonationCreditRule>
): AddMultipleAction => ({
  type: ADD_MULTIPLE,
  donationCreditRules,
});

export type UpdateAction = {
  type: typeof UPDATE;
  donationCreditRule: DonationCreditRule;
};
export const updateAction = (donationCreditRule: DonationCreditRule): UpdateAction => ({
  type: UPDATE,
  donationCreditRule,
});

export type RemoveAction = {
  type: typeof REMOVE;
  id: string;
};
export const removeAction = (id: string): RemoveAction => ({
  type: REMOVE,
  id,
});

export type DonationCreditRuleActions = AddAction | AddMultipleAction | UpdateAction | RemoveAction;
